import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { PaymentState, StateWithPayment } from '../payment-state';
import { getPaymentState } from './state.selectors';

const getDeletePaymentState: MemoizedSelector<StateWithPayment, StateUtils.LoaderState<void>> = createSelector(
  getPaymentState,
  (state: PaymentState) => state.deletePayment,
);

export const getDeletePaymentLoading: MemoizedSelector<StateWithPayment, boolean> = createSelector(
  getDeletePaymentState,
  (state: StateUtils.LoaderState<void>) => StateUtils.loaderLoadingSelector(state),
);

export const getDeletePaymentError: MemoizedSelector<StateWithPayment, boolean> = createSelector(
  getDeletePaymentState,
  (state: StateUtils.LoaderState<void>) => StateUtils.loaderErrorSelector(state),
);
